import Vue from "vue";
import App from "./App.vue";
import router from "../router";
import vuetify from "./plugins/vuetify";

import "@mdi/font/scss/materialdesignicons.scss";

import vueDateFormat from "vue-date-format";
Vue.use(vueDateFormat);

import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import { sync } from "vuex-router-sync";
import store from "@/store";
// Sync store with router
sync(store, router);

// importing the helper
// import interceptorsSetup from "./helpers/interceptors";
// and running it somewhere here
// interceptorsSetup();

// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import VueCkeditor from "vue-ckeditor5";

const ckOptions = {
  config: { language: "pt" },
  // editors: {
  //   classic: ClassicEditor
  // },
  name: "ckeditor"
};

// Vue.use(VueCkeditor.plugin, ckOptions);

Vue.config.productionTip = false;

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then(registration => {})
    .catch(error => {
      console.log("Erro ao registrar Service Worker:", error);
    });
}

new Vue({
  render: h => h(App),
  vuetify,
  router,
  store
}).$mount("#app");
